import { render, staticRenderFns } from "./CatalogPromotions.vue?vue&type=template&id=53e392e6&"
import script from "./CatalogPromotions.vue?vue&type=script&lang=js&"
export * from "./CatalogPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports